import { BoxIRemoteBloc } from "./bloc.box";
import { CloudIRemoteBloc } from "./bloc.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseIRemoteBloc } from "./bloc.base";
import environment from "@/config";

export default getService<BaseIRemoteBloc>(environment.nexus, {
    box: new BoxIRemoteBloc(),
    cloud: new CloudIRemoteBloc(),
});